{
  "name": "shadcn",
  "version": "2.7.0",
  "description": "Add components to your apps.",
  "publishConfig": {
    "access": "public"
  },
  "license": "MIT",
  "author": {
    "name": "shadcn",
    "url": "https://twitter.com/shadcn"
  },
  "repository": {
    "type": "git",
    "url": "https://github.com/shadcn/ui.git",
    "directory": "packages/shadcn"
  },
  "files": [
    "dist"
  ],
  "keywords": [
    "components",
    "ui",
    "tailwind",
    "radix-ui",
    "shadcn"
  ],
  "type": "module",
  "exports": {
    ".": {
      "types": "./dist/index.d.ts",
      "default": "./dist/index.js"
    },
    "./registry": {
      "types": "./dist/registry/index.d.ts",
      "default": "./dist/registry/index.js"
    },
    "./mcp": {
      "types": "./dist/mcp/index.d.ts",
      "default": "./dist/mcp/index.js"
    }
  },
  "bin": "./dist/index.js",
  "scripts": {
    "dev": "tsup --watch",
    "build": "tsup",
    "typecheck": "tsc --noEmit",
    "clean": "rimraf dist && rimraf components",
    "start:dev": "cross-env REGISTRY_URL=http://localhost:4000/r node dist/index.js",
    "start:prod": "cross-env REGISTRY_URL=https://ui.shadcn.com/r node dist/index.js",
    "start": "node dist/index.js",
    "format:write": "prettier --write \"**/*.{ts,tsx,mdx}\" --cache",
    "format:check": "prettier --check \"**/*.{ts,tsx,mdx}\" --cache",
    "release": "changeset version",
    "pub:beta": "pnpm build && pnpm publish --no-git-checks --access public --tag beta",
    "pub:next": "pnpm build && pnpm publish --no-git-checks --access public --tag next",
    "pub:release": "pnpm build && pnpm publish --access public",
    "test": "vitest run",
    "test:dev": "REGISTRY_URL=http://localhost:4000/r vitest run"
  },
  "dependencies": {
    "@antfu/ni": "^23.2.0",
    "@babel/core": "^7.22.1",
    "@babel/parser": "^7.22.6",
    "@babel/plugin-transform-typescript": "^7.22.5",
    "@modelcontextprotocol/sdk": "^1.10.2",
    "commander": "^10.0.0",
    "cosmiconfig": "^8.1.3",
    "deepmerge": "^4.3.1",
    "diff": "^5.1.0",
    "execa": "^7.0.0",
    "fast-glob": "^3.3.2",
    "fs-extra": "^11.1.0",
    "https-proxy-agent": "^6.2.0",
    "kleur": "^4.1.5",
    "msw": "^2.7.1",
    "node-fetch": "^3.3.0",
    "ora": "^6.1.2",
    "postcss": "^8.4.24",
    "prompts": "^2.4.2",
    "recast": "^0.23.2",
    "stringify-object": "^5.0.0",
    "ts-morph": "^18.0.0",
    "tsconfig-paths": "^4.2.0",
    "zod": "^3.20.2",
    "zod-to-json-schema": "^3.24.5"
  },
  "devDependencies": {
    "@types/babel__core": "^7.20.1",
    "@types/diff": "^5.0.3",
    "@types/fs-extra": "^11.0.1",
    "@types/prompts": "^2.4.2",
    "@types/stringify-object": "^4.0.5",
    "rimraf": "^6.0.1",
    "tsup": "^6.6.3",
    "type-fest": "^3.8.0",
    "typescript": "^4.9.3"
  }
}
